// extracted by mini-css-extract-plugin
export var contact = "JoinUsContent-module--contact--MqnfY";
export var list = "JoinUsContent-module--list--UDXTz";
export var openPositionsContainer = "JoinUsContent-module--open-positions-container--f2p3I";
export var paragraph = "JoinUsContent-module--paragraph--7BEJR";
export var titleStyle = "JoinUsContent-module--titleStyle--MFXSd";